import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import UnifiedComputeResource from '../UnifiedCompute.resource';
export const defaultReducerState = {
    res: getDefaultAsyncWrapperObj(),
};
// Action Types
const prefix = 'getComputeList';
const CLEAR_GET_COMPUTE_STATE = `${prefix}/CLEAR_STATE`;
export const clearGetComputeListState = () => {
    return {
        type: CLEAR_GET_COMPUTE_STATE,
        payload: {},
    };
};
const getComputeArgs = {
    actionPrefix: `${prefix}/LOAD`,
    reduxKeyNested: () => ['res'],
    loadResource: (inputPayload) => {
        return UnifiedComputeResource.getComputeList(inputPayload.workspaceId, inputPayload.search);
    },
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const getComputeListEpicReducer = loadResourcesUtils(getComputeArgs);
// Reducer
export const getComputeListReducer = (state = defaultReducerState, action) => {
    switch (action.type) {
        case CLEAR_GET_COMPUTE_STATE:
            return defaultReducerState;
        default:
            return getComputeListEpicReducer.reduxChange(state, action);
    }
    return state;
};
export default getComputeListReducer;

//# sourceMappingURL=GetComputeList.ducks.js.map
